<template>
  <div class="alert alert-success">
    <h3>Broadcast Test</h3>
    <div class="float-right">
      <button class="btn btn-light" v-on:click="connect">Join</button>
      <button class="btn btn-danger" v-on:click="disconnect">Leave</button>
    </div>
    <div>
      <button class="btn btn-success" v-on:click="callTest">CALL TEST</button>
      here: {{ here }}
    </div>
    <p>
      Get Response: {{ getResponse }}
    </p>
    <p>
      Broadcast message [{{ messageCounter }}]: {{ message }}
    </p>
    <p>
      Users: <span v-for="user in users">{{ user.email }}</span>
    </p>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      messageCounter: 0,
      message: '',
      getResponse: '',
      here: false,
      users: [],
      channel: null,
    };
  },
  methods: {
    callTest() {
      this.getResponse = '';
      axios
        .get('/ajax/test/call-test-event')
        .then(response => {
          this.getResponse = response.data;
        })
        .catch(response => {
          this.getResponse = 'ERROR!';
        });
    },

    connect() {
      let vm = this;
      this.channel = Echo.channel('test')
        .listen('TestMessage', (event) => {
          vm.messageCounter++;
          vm.message = event.message;
        });
    },
    disconnect() {
      Echo.leave('test');
    },
  },
  mounted() {
    this.connect();
  },
};
</script>
